import { ChangeEvent, FC, useCallback, useMemo } from 'react';
import { avnuDisabledLiquiditySourcesAtom } from '../../../../atoms';
import ToggleSwitch from '../../ToggleSwitch';
import Typography from '../../Typography';

import './SwapSourceItem.scss';
import { useAtom } from '../../../../lib/state';

interface SourceItemProps {
  name: string;
}

const SwapSourceItem: FC<SourceItemProps> = ({ name }) => {
  const [avnuDisabledLiquiditySources, setAvnuDisabledLiquiditySources] = useAtom(avnuDisabledLiquiditySourcesAtom);

  const disabled = useMemo(() => {
    return avnuDisabledLiquiditySources.includes(name);
  }, [avnuDisabledLiquiditySources, name]);

  const onToggle = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      let newAvnuDisabledLiquiditySources: string[] = [];
      if (event.target.checked) {
        newAvnuDisabledLiquiditySources = avnuDisabledLiquiditySources.filter(source => source !== name);
      } else {
        newAvnuDisabledLiquiditySources = [...avnuDisabledLiquiditySources, name];
      }

      setAvnuDisabledLiquiditySources(newAvnuDisabledLiquiditySources);
    },
    [avnuDisabledLiquiditySources, name, setAvnuDisabledLiquiditySources],
  );

  return (
    <div className="nostra__swapSettings__liquiditySourcesItem">
      <Typography variant="input-body-lg">{name}</Typography>
      <ToggleSwitch checked={!disabled} onChange={onToggle} />
    </div>
  );
};
export default SwapSourceItem;
